import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { styleEntry } from '@mylighthouse/prism-ember';

interface GeneralCalendarsDaysDayLoadingSignature {
  Args: {
    dayComponentHeight: number;
  };
}

const GeneralCalendarsDaysDayLoading = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <span class="ins-calendar-day-container">
    <div
      class="ins-calendar-day"
      style={{styleEntry "height" (concat @dayComponentHeight "px")}}
    >
      <div class="calendar-day-content">
        <div class="calendar-day-content__placeholder"></div>
        <div class="day-info-block-wrapper">
          <div class="day-info-aligned-block">
            <div class="own-rate-container"></div>
            <div class="comp-percentage-container"></div>
          </div>
        </div>
      </div>
    </div>
  </span>
</template> satisfies TOC<GeneralCalendarsDaysDayLoadingSignature>;

export default GeneralCalendarsDaysDayLoading;
